{
  "sendMessage": "Send a message...",
  "messageInput": "Message input",
  "copy": "Copy",
  "exportAsMarkdown": "Export as Markdown",
  "refresh": "Refresh",
  "previous": "Previous",
  "next": "Next",
  "cancel": "Cancel",
  "update": "Update",
  "somethingWentWrong": "Something went wrong",
  "assistantError": "The assistant couldn't complete your request. You can try again or rephrase your message.",
  "edit": "Edit",
  "scrollToBottom": "Scroll to bottom",
  "newThread": "New Thread",
  "archiveThread": "Archive thread",
  "back": "Back",
  "continue": "Continue",
  "complete": "Complete",
  "current": "Current",
  "showDetails": "Show details",
  "checkConsoleForDetails": "Check console for details",
  "dataPending": "data pending",
  "noDataFound": "No data found for output key \"{{outputKeyRef}}\". The query may still be processing.",
  "noData": "No {{blockType}} data",
  "queryReturnedNoResults": "The query returned no results."
}
